import React from 'react';
import { Text, View } from 'react-native';
import { Focusable } from '../Focusable';
import { Icon } from '../Icon';
import { createStyleSheet } from '../../utils';
import { useStyleSheet, useThemeContext } from '../../hooks';
export const Link = ({ type, text, leftIcon, rightIcon, disabled, style, onPress }) => {
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    const iconColor = {
        primary: color.primary.solid,
        secondary: color.invert2.p100
    };
    const iconHoverColor = {
        primary: color.primary.solidHover,
        secondary: color.invert2.p68
    };
    return (React.createElement(Focusable, { style: [styles.container, style], onPress: disabled ? void 0 : onPress, disabled: disabled }, ({ hovered }) => (React.createElement(React.Fragment, null,
        leftIcon ? (React.createElement(View, { style: styles.leftIcon },
            React.createElement(Icon, { name: leftIcon, size: 21, color: hovered ? iconHoverColor[type] : iconColor[type] }))) : null,
        React.createElement(Text, { style: [
                styles.text,
                styles[type],
                hovered ? styles[`${type}Hover`] : {}
            ] }, text),
        rightIcon ? (React.createElement(View, { style: styles.rightIcon },
            React.createElement(Icon, { name: rightIcon, size: 21, color: hovered ? iconHoverColor[type] : iconColor[type] }))) : null))));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        alignItems: 'center',
        flexDirection: 'row'
    },
    text: {
        fontWeight: '600',
        fontSize: size.F,
        lineHeight: size.H,
        letterSpacing: -0.01
    },
    primary: {
        color: color.primary.solid
    },
    secondary: {
        color: color.invert2.p100
    },
    primaryHover: {
        color: color.primary.solidHover
    },
    secondaryHover: {
        color: color.invert2.p68
    },
    leftIcon: { marginRight: size.B },
    rightIcon: { marginLeft: size.B }
}));
//# sourceMappingURL=index.js.map